import _ from "lodash";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { getRelativePath } from "Utils";
import { getNextMenuRoute } from "Administrator/modules/AdministratorModule";
import { Foundation } from "./routes";
export default store => ({
  path: "academy-analytics",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "toddleAnalytics" */ "./components"),
      ]).then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  onEnter(nextState, replace) {
    if (_.last(nextState.routes).path == "academy-analytics") {
      const route = getNextMenuRoute("ACADEMY_ANALYTICS");
      if (route) {
        replace(getRelativePath(route));
      } else {
        replace(getRelativePath("../"));
      }
    }
  },
  childRoutes: [Foundation(store)],
});
